import { colors } from '@sitoo/mui-theme/lib/colors';

const injectPalette = (theme, mode) => {
  const isLight = mode === 'light';
  const palette = {
    mode,
    primary: {
      light: colors.blueBase,
      main: colors.blue80,
      dark: colors.blue70,
      contrastText: colors.white
    },
    secondary: {
      light: isLight ? colors.green10 : colors.green40,
      main: colors.greenBase,
      dark: colors.green60,
      contrastText: colors.blue80
    },
    error: {
      light: isLight ? colors.red10 : colors.red40,
      main: colors.redBase,
      dark: colors.red60,
      contrastText: colors.blue80
    },
    warning: {
      light: isLight ? colors.orange10 : colors.orange40,
      main: colors.orangeBase,
      dark: colors.orange60,
      contrastText: colors.blue80
    },
    info: {
      light: isLight ? colors.blue10 : colors.blue40,
      main: colors.blueBase,
      dark: colors.blue60,
      contrastText: colors.blue80
    },
    success: {
      light: isLight ? colors.green10 : colors.green40,
      main: colors.greenBase,
      dark: colors.green60,
      contrastText: colors.blue80
    },
    text: {
      primary: isLight ? colors.blue80 : colors.gray10,
      secondary: isLight ? colors.gray70 : colors.darkMode20,
      disabled: isLight ? colors.gray50 : colors.gray30
    },
    background: {
      default: isLight ? colors.gray10 : colors.darkMode60,
      paper: isLight ? colors.white : colors.darkMode50,
      page: isLight ? colors.gray20 : colors.darkMode60
    },
    divider: isLight ? colors.gray40 : colors.darkMode30,
    gray: {
      main: colors.gray40,
      contrastText: colors.darkBlue
    },
    green: {
      main: colors.greenBase,
      contrastText: colors.white
    },
    orange: {
      main: colors.orangeBase,
      contrastText: colors.white
    },
    red: {
      main: colors.redBase,
      contrastText: colors.white
    },
    blue: {
      main: colors.blueBase,
      contrastText: colors.white
    },
    black: {
      main: colors.darkBlue,
      contrastText: colors.white
    },
    yellow: {
      main: colors.yellow,
      contrastText: colors.black
    },
    // Tertiary Button
    tertiary: {
      main: colors.gray20
    }
  };
  Object.assign(theme.palette, {
    ...colors,
    ...palette
  });
  return theme;
};

export { injectPalette };
